<template>
  <div>
    <PageTitle :title="$t('global.upgrade-your-plan')" />
    <div class="row">
      <div class="col-md-12">
        <Card :disable-title="true">
          <div class="text-center">
            <div class="text-primary my-4">{{ $t("global.thank-you-for-choosing-nexcess") }}</div>
            <div class="mb-4">{{ $t("global.free-trial-upgrade-success-desc") }}</div>
            <div class="mb-4">
              <router-link class="mx-4" :to="{ name: 'plans' }">
                {{ $t("global.go-to-my-plans") }}
              </router-link>
              <router-link class="mx-4" :to="{ name: 'support' }">
                {{ $t("global.go-to-my-support") }}
              </router-link>
            </div>
          </div>
        </Card>
      </div>
    </div>
  </div>
</template>

<script>
import Card from "@/components/display/Card";
import { onMounted } from "@vue/composition-api";
import PageTitle from "@/components/display/PageTitle";
import store from "@/store";

export default {
  name: "FreeTrialUpgradeThankYou",
  components: {
    PageTitle,
    Card,
  },
  props: {
    planId: Number,
  },
  setup(props) {
    onMounted(() => {
      store.dispatch("plans/getItem", props.planId);
    });

    return {};
  },
};
</script>
